<div class="nt-div">
  <div class="d-flex flex-row justify-content-between align-items-center" (click)="$event.stopPropagation()">
    <div class="d-flex justify-content-start gap-2">
      <!-- <div class="nt-head">
        Benachrichtigungen
      </div> -->
      <mat-icon
          *ngIf="this.unseenCount > 0"
          class="notification-icon"
          matBadge="{{ this.unseenCount }}"
          matBadgeColor="warn"
          matTooltip="Benachrichtigungen"
          aria-hidden="false"
          >notifications</mat-icon
        >
        <mat-icon *ngIf="this.unseenCount === 0" class="notification-icon"
          >notifications</mat-icon
        >
    </div>
    <div class="d-flex flex-row justify-content-between gap-2">
      <label class="toggle-switch">
        <input type="checkbox" [(ngModel)]="showUnread" (click)="this.toggleSwitch()">
        <span class="slider">
          <mat-icon class="right-icon" *ngIf="showUnread">done</mat-icon>
          <mat-icon class="cross-icon" *ngIf="!showUnread">close</mat-icon>
        </span>
      </label>
      <div>Nur ungelesene anzeigen</div>
    </div>
  </div>
  <div *ngIf="!isLoading" class="mt-3">
    <div class="mt-3 mb-3 d-flex justify-content-end mark-read" (click)="$event.stopPropagation()">
      <div *ngIf="notifications.length > 0 && unseenCount > 0" class="cursor-pointer" (click)="$event.stopPropagation()" (click)="markAllAsRead()">
        Alles als gelesen markieren
      </div>
    </div>
    <ng-container *ngIf="notifications.length > 0; else noMessages">
      <div class="notification-list">
        <div *ngFor="let notification of notifications" [ngClass]="{'unread-border': notification.isRead === 'N'}" class="notification-item">
          <input class="checkbox" type="checkbox" *ngIf="notification.isRead === 'N'" (change)="markAsRead(notification.id)" (click)="$event.stopPropagation()">
          <div class="notification-message" [ngClass]="{'read-margin': notification.isRead === 'Y'}" (click)="$event.stopPropagation()">
            {{ notification.expenseId + ', '}} {{ notification.message }}
            <div class="d-flex justify-content-start gap-1 sub-nt">
              <div>Buchhaltung:</div>
              <div>{{ notification.notificationFromName }}</div>
              <div>{{ util.dateHtml(notification.timestamp) }}</div>
            </div>
          </div>
          <div mat-icon-button class="button cursor-pointer" (click)="goToForm(notification)">
            <mat-icon>open_in_new</mat-icon>
          </div>
        </div>
      </div>
    </ng-container>
    <ng-template #noMessages (click)="$event.stopPropagation()">
      <div class="no-messages d-flex justify-content-center">Sie haben keine neuen Benachrichtigungen</div>
    </ng-template>
  </div>
</div>

<div class="spinner-container flex flex-col gap-2" *ngIf="isLoading">
  <mat-spinner class="custom-spinner" diameter="50"></mat-spinner>
</div>
